define(function (require) {
  var Forms = require('app/modules/forms');
  var FIELDS = ['university', 'degree', 'major', 'start', 'grade', 'location', 'description', 'is_currently_studying'];

  var getInputName = function(name, model_name){
    if(!model_name){
      model_name = 'job_application';
    }
    return model_name + '[degrees_attributes][]['+name+']';
  };

  var getInputsData = function(container){
    var result = {};

    FIELDS.forEach(function(field_name) {
      var field = container.find('#degree-' + field_name);

      if(field.attr('type') !== 'checkbox'){
        result[field_name] = field.val();
      } else {
        result[field_name] = field.is(':checked');
      }
    });

    return result;
  };

  var clearFields = function(fields){
    fields.find('input, textarea').not('.checkbox-icheck').val('');
    fields.find('select').val('').trigger("chosen:updated");
    fields.find('.checkbox-icheck').iCheck('uncheck');
    if ($(".chosen-results").css("overflow") == "auto") {
      $(".chosen-results").css("overflow", "hidden");
    } else {
      $(".chosen-results").css("overflow", "auto");
    }
  };

  var addHtml = function(data, beforeElement, model_name, clean){
    if(data.university && data.start && data.degree && data.major){
      var _template = $('li.education-fields.degree.clearfix.dn');
      var template = _template.clone();
      template.removeClass('dn');
      template.find('.range').html(data.start+' &mdash; '+data.grade);
      template.find('.object-name').prepend(data.university);

      if(data.id){
        template.find('.remove-experience').attr('data-url', '/degrees/'+data.id);
        template.find('input').remove();
      } else {
        FIELDS.forEach(function(field_name) {
          template.find('input[name=' + field_name + ']').attr({
            name: getInputName(field_name, model_name),
            value: data[field_name]
          });
        });
      }
      if (!clean) {
        clearFields(beforeElement);
      }
      template.insertBefore(beforeElement);
    }
  };

  var add = function (link, model_name) {
    var container = $('.education-fields.education-new');
    var user_inputs = getInputsData(container);

    if(link){
      var section = link.parents('.section-education');

      $.ajax({
        type: 'POST',
        url: link.attr('data-url'),
        data: { degree: user_inputs },
        success: function(result){
          Forms.hideErrors(section);

          if(result.errors_html){
            Forms.showErrors(section, [], '', result.errors_html);
          } else {
            var degree = $.parseJSON(result.degree);
            addHtml({ id: degree.id,
                      university: degree.university,
                      start: degree.date_start,
                      grade: degree.date_grade,
                      degree: degree.degree,
                      major: degree.major
                    }, container, model_name);
          }
        }
      });
    } else {
      addHtml(user_inputs, container, model_name);
    }
  };

  var remove = function(link){
    var url = link.attr('data-url');

    if(url){
      $.ajax({
        type: 'DELETE',
        url: url,
        success: function(result){
          if(result.status == 'ok'){
            link.parents('li.education-fields').remove();
          }
        }
      });
    } else {
      var parent = link.parents('li.education-fields');
      var destroy = parent.find('[name*=_destroy]');
      if(destroy.length) {
        parent.addClass('dn');
        destroy.val(true);
      }else{
        parent.remove();
      }
    }
  };

  return {
    add: add,
    remove: remove,
    addHtml: addHtml
  };
});
